import React from 'react';
import Gallery from "react-photo-gallery-react17";
import { useTranslation } from 'react-i18next'
import {NavLink } from 'react-router-dom';




const GalleryRosewood = () =>{

    const { t, i18n } = useTranslation()



  const photos = [
    {}
  ];


  const photosTeak = [
    {
      src: "../images/galleryRosewood/RS1.jpg",
      width: 1,
      height: 1
    },
    {
      src: "../images/galleryRosewood/RS2.jpg",
      width: 1,
      height: 1
    },
    {
      src: "../images/galleryRosewood/RS3.jpg",
      width: 1,
      height: 1
     },
     {
        src: "../images/galleryRosewood/RS4.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/galleryRosewood/RS5.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/galleryRosewood/RS6.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/galleryRosewood/RS7.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/galleryRosewood/RS8.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/galleryRosewood/RS9.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/galleryRosewood/RS10.jpg",
        width: 2,
        height: 1
       }


    ]

    return(
        <>

           <div className="container-fluid nav-bg" >
                <div className="row">
                    <div className="col-12 mx-auto">
                        <div className="col-12 mx-auto bg-light">
                                <div class="p-1 w-auto h-25 bg-light "> 
                                <strong>
                                      <NavLink to="/Gallery" >
                                        {t('menu.gallery')}
                                      </NavLink>
                                     - {t('gallery.rosewood')}
                                    </strong>
                                </div>
                                <div className="p-1"></div>
                                <div>
                                    <Gallery photos={photosTeak}/>
                                </div>


                        </div>
                    </div>
                </div>
            </div> 

        </>
    );
}

export default GalleryRosewood